import React from 'react';

interface ChatOutlineIconProps {
  size?: number;
  color?: string;
}

const ChatOutlineIcon: React.FC<ChatOutlineIconProps> = ({
  size = 20,
  color = 'currentColor',
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.3882 5.87714C11.5847 5.87714 12.7321 6.35241 13.578 7.1984C14.424 8.04439 14.8993 9.1918 14.8993 10.3882C14.9022 11.2762 14.6397 12.1448 14.1457 12.8826L14.8993 14.8993L12.3625 14.4429C11.7524 14.7404 11.083 14.8964 10.4043 14.8993C9.72552 14.9021 9.05487 14.7517 8.44229 14.4594C7.8297 14.1671 7.291 13.7402 6.8663 13.2108C6.4416 12.6813 6.14185 12.0628 5.98941 11.4013C5.83697 10.74 5.83573 10.0526 5.98583 9.39069C6.13593 8.72873 6.43347 8.10917 6.85628 7.57818C7.27909 7.04719 7.81628 6.61847 8.42781 6.32395C9.03935 6.02942 9.70946 5.87669 10.3882 5.87714Z" stroke={color} strokeWidth="1.14" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.0357 3.23423C10.3209 2.32466 9.34028 1.66061 8.23036 1.33453C7.12043 1.00845 5.93645 1.03658 4.84326 1.41499C3.75008 1.7934 2.80209 2.50327 2.13128 3.44575C1.46048 4.38823 1.10024 5.51643 1.10073 6.67326C1.09744 7.7729 1.4227 8.84847 2.03479 9.76202L1.10073 12.2457L3.35096 11.8424" stroke={color} strokeWidth="1.14" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ChatOutlineIcon;
